import { faKey } from '@fortawesome/pro-solid-svg-icons';
import { type FC } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from '~//_shared/utils/hooks';
import {
  activeMapElementsClearState, activeMapElementsSetActiveMasterKey,
} from '~//store/frontendState/activeMapElements/activeMapElements.actionCreators';
import { useIsMapKeyPanelOpen } from '~/store/frontendState/activeMapElements/activeMapElements.selectors';
import { RightSideMapToolsMenuItem } from './rightSideMapToolsMenuItem.component';

export const RightSideMapKeyMenuItemContainer: FC = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const isMapKeyPanelOpen = useIsMapKeyPanelOpen();

  const toggleListVisibility = () => {
    if (isMapKeyPanelOpen) {
      dispatch(activeMapElementsClearState());
    }
    else {
      dispatch(activeMapElementsSetActiveMasterKey());
    }
  };

  return (
    <RightSideMapToolsMenuItem
      icon={faKey}
      active={isMapKeyPanelOpen}
      onClick={toggleListVisibility}
      tooltip={t('Map Key')}
    />
  );
};
